import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-primary-800 text-white pt-16 pb-8">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({top: 0, behavior: 'smooth'}); }} className="cursor-pointer">
              <h3 className="text-2xl font-bold mb-6">
                Smooth<span className="text-accent-400">Staffing</span>
              </h3>
            </a>
            <p className="text-primary-100 mb-6">
              Connecting businesses with expert virtual assistants to save time and scale operations.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#more-services" className="text-primary-100 hover:text-white transition-colors">Virtual Assistants</a></li>
              <li><a href="#more-services" className="text-primary-100 hover:text-white transition-colors">Executive Assistants</a></li>
              <li><a href="#more-services" className="text-primary-100 hover:text-white transition-colors">Real Estate VAs</a></li>
              <li><a href="#more-services" className="text-primary-100 hover:text-white transition-colors">Social Media Management</a></li>
              <li><a href="#more-services" className="text-primary-100 hover:text-white transition-colors">Customer Support</a></li>
              <li><a href="#more-services" className="text-primary-100 hover:text-white transition-colors">Administrative Support</a></li>
            </ul>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-primary-100 hover:text-white transition-colors">About Us</a></li>
              <li><a href="#services" className="text-primary-100 hover:text-white transition-colors">Services</a></li>
              <li><a href="#how-it-works" className="text-primary-100 hover:text-white transition-colors">How It Works</a></li>
              <li><a href="#implementation" className="text-primary-100 hover:text-white transition-colors">Implementation</a></li>
            </ul>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center">
                <svg
                  className="w-5 h-5 text-primary-300 mr-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
                <a href="tel:+14255772676" className="text-primary-100 hover:text-white transition-colors">
                  (425) 577-2676
                </a>
              </li>
            </ul>
          </motion.div>
        </div>
        
        <div className="border-t border-primary-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-primary-300 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} Smooth Staffing. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-primary-300 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-primary-300 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-primary-300 hover:text-white text-sm transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;